export default "__VITE_ASSET__52d4f419__"